import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.number.is-nan.js";
import dayjs from 'dayjs';

// Returns true whenever signedUrl can't be positively confirmed as valid and
// unexpired, so callers always fall back to fetching a fresh one
var isSignedUrlExpired = function isSignedUrlExpired(signedUrl) {
  if (!signedUrl) {
    return true;
  }
  try {
    var parsedUrl = new URL(signedUrl);

    // X-Amz-Date's compact format (YYYYMMDDTHHmmssZ) needs separators before dayjs can parse it.
    var issuedAt = dayjs(parsedUrl.searchParams.get('X-Amz-Date').replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/, '$1-$2-$3T$4:$5:$6Z'));
    var rawExpires = parsedUrl.searchParams.get('X-Amz-Expires');
    var expiresInSeconds = Number(rawExpires);
    if (!issuedAt.isValid() || rawExpires === null || Number.isNaN(expiresInSeconds)) {
      return true;
    }
    return dayjs().isAfter(issuedAt.add(expiresInSeconds, 'second'));
  } catch (e) {
    return true;
  }
};
export default isSignedUrlExpired;